/*
 * @Author: wuqinfa
 * @Date: 2024-04-22 15:23:25
 * @LastEditors: wuqinfa
 * @Description: 
 */
import request from '@/utils/request';

/**
 * 问卷分页查询接口
 */
export async function surveyPage(params: any) {
  return request('/crm-campus/survey/page', {
    method: 'POST',
    data: params,
  });
}

/**
 * 保存问卷接口
 */
export async function surveySave(params: any) {
  return request('/crm-campus/survey/save', {
    method: 'POST',
    data: params,
  });
}

/**
 * 获取问卷详情
 */
export async function surveyDetail(params: any) {
  return request('/crm-campus/survey/detail', {
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

/**
 * 提交问卷接口
 */
export async function surveySubmit(params: any) {
  return request('/crm-campus/survey/submit', {
    method: 'POST',
    data: params,
  });
}

/**
 * 问卷明细导出接口
 */
export async function surveyExport(params: any) {
  return request('/crm-campus/survey/export', {
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    responseType: 'blob',
  });
}

/**
 * 修改问卷状态
 */
export async function surveyUpdateStatus(params: any) {
  return request('/crm-campus/survey/updateStatus', {
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

/**
 * 获取全部学校
 */
export async function getSchoolList(params: any) {
  return request('/crm-campus/school/list', {
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

/**
 * 获取全部学校
 */
export async function surveyTemplateQuery(params: any) {
  return request('/crm-campus/surveyTemplate/query', {
    method: 'POST',
    data: params,
  });
}

/**
 * 关联学校
 */
export async function getScopeSchool(params: any) {
  return request('/crm-campus/school/getScopeSchool', {
    method: 'GET',
    params: params
  });
}

/**
 * 获取模板问卷详情
 */
export async function surveyTemplateDetail(params: any) {
  return request('/crm-campus/surveyTemplate/detail', {
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}